import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AccountProfile } from '../components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  selectProfileEditable,
  setProfileEditableAction,
  updateAccountProfileActions,
  fetchIdCardInfoActions,
  acceptAccountDocumentsActions,
  rejectAccountDocumentsActions,
  fetchAccountUpdateLogsActions,
  selectAccountUpdateLogs,
  selectDocuments,
  fetchAccountDocumentsActions,
  impersonateUserActions,
} from '../ducks';
import { selectAccount as selectAdminAccount } from '../../auth/ducks'
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { apiCallIds } from '../api';
import Spin from 'antd/lib/spin';
import moment from 'moment';
import { selectIsCallCentrum, selectToken } from '../../auth/ducks';
import { accountRoles } from '../../../common/enums';
import { push } from 'react-router-redux';

const mapStateToProps = state => ({
  profileEditable: selectProfileEditable(state),
  isUpdating: selectIsInProgress(state, apiCallIds.UPDATE_ACCOUNT_PROFILE) || selectIsInProgress(state, apiCallIds.IMPERSONATE_USER),
  isFetching: selectIsInProgress(state, apiCallIds.FETCH_ACCOUNT),
  isFetchingIdCardInfo: selectIsInProgress(state, apiCallIds.FETCH_ID_CARD_INFO),
  isCallCentrum: selectIsCallCentrum(state),
  accountUpdateLogs: selectAccountUpdateLogs(state),
  documents: selectDocuments(state),
  token: selectToken(state),
  adminAccount: selectAdminAccount(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      acceptAccountDocuments: acceptAccountDocumentsActions.request,
      rejectAccountDocuments: rejectAccountDocumentsActions.request,
      setProfileEditable: setProfileEditableAction,
      updateAccountProfile: updateAccountProfileActions.request,
      fetchIdCardInfo: fetchIdCardInfoActions.request,
      fetchAccountUpdateLogs: fetchAccountUpdateLogsActions.request,
      fetchAccountDocuments: fetchAccountDocumentsActions.request,
      impersonateUser: impersonateUserActions.request,
    },
    dispatch
  ),
  goTo: pathname => dispatch(push({ pathname })),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class AccountProfileContainer extends Component {
  static propTypes = {
    profileEditable: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    account: PropTypes.object,
    accountId: PropTypes.string,
    isUpdating: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isCallCentrum: PropTypes.bool.isRequired,
    goTo: PropTypes.func.isRequired,
    accountUpdateLogs: PropTypes.object,
    adminAccount: PropTypes.object,
  };

  componentDidUpdate(prevProps) {
    const { account, isFetching, goTo, isCallCentrum } = this.props;
    if (
      prevProps.account !== account &&
      account && ((
        account.idCardInfo && (
          moment(account.idCardInfo.dateChecked).isBefore(moment().subtract(1, 'day')) ||
          account.idCardInfo.idCardNumber !== account.profileData.idCardNumber
        )
      ) || (
          !account.idCardInfo
        ))
    ) {
      this.updateIdCardInfo();
    }
    if (prevProps.account !== account) {
      this.getAccountUpdateLogs()
    }
    if (prevProps.account !== account && !isFetching && isCallCentrum && (account.role !== accountRoles.DEBTOR && account.role !== accountRoles.CREDITOR)) {
      goTo('/cc');
    }
  }

  componentDidMount() {
    const { actions, accountId } = this.props;
    actions.fetchAccountDocuments(accountId);
  }

  componentWillUnmount() {
    this.props.actions.setProfileEditable('');
  }

  onSubmit = (profileData) => {
    const { actions, accountId, account } = this.props;
    const updateIfDefined = param => profileData[param] == null ? account[param] : profileData[param];
    const updateIfDefinedInPD = param => profileData[param] == null ? account.profileData[param] : profileData[param];
    const updateIfDefinedInED = param => profileData[param] == null ? account.employersData[param] : profileData[param];
    const newAccount = {
      address: updateIfDefinedInPD('address'),
      deliveryAddress: updateIfDefinedInPD('deliveryAddress'),
      phone: updateIfDefinedInPD('phone'),
      phoneActive: updateIfDefinedInPD('phoneActive'),
      phonePrefered: updateIfDefinedInPD('phonePrefered'),
      phoneChecked: updateIfDefinedInPD('phoneChecked'),
      phoneNotContact: updateIfDefinedInPD('phoneNotContact'),
      phoneAnotherPerson: updateIfDefinedInPD('phoneAnotherPerson'),
      ...(account.role === accountRoles.DEBTOR && {
        employer: updateIfDefinedInPD('employer'),
        socialStatus: updateIfDefinedInPD('socialStatus'),
        gender: updateIfDefinedInPD('gender'),
        income: updateIfDefinedInPD('income'),
        costs: updateIfDefinedInPD('costs'),
        maritalStatus: updateIfDefinedInPD('maritalStatus'),
        kids: updateIfDefinedInPD('kids'),
        incomeFrom: updateIfDefinedInPD('incomeFrom'),
        sector: updateIfDefinedInPD('sector'),
        insuranceTaxDebt: updateIfDefinedInPD('insuranceTaxDebt'),
      }),
      personalNumber: updateIfDefinedInPD('personalNumber'),
      idCardNumber: updateIfDefinedInPD('idCardNumber'),
      education: updateIfDefinedInPD('education'),
      ...(account.role === accountRoles.CREDITOR && {
        declarationOfLegalIncome: updateIfDefinedInPD('declarationOfLegalIncome'),
      }),
      iban: updateIfDefinedInPD('iban'),
      nameFirst: updateIfDefined('nameFirst'),
      nameLast: updateIfDefined('nameLast'),
      birthLastName: updateIfDefined('birthLastName'),
      email: updateIfDefinedInPD('email'),
      emailPrefered: updateIfDefinedInPD('emailPrefered'),
      emailNotContact: updateIfDefinedInPD('emailNotContact'),
      emailAnotherPerson: updateIfDefinedInPD('emailAnotherPerson'),
      emailUndeliverable: updateIfDefinedInPD('emailUndeliverable'),
      locked: updateIfDefined('locked'),
      phoneNumbers: profileData.phoneNumbers || [],
      emails: profileData.emails || [],
      interest0_6: updateIfDefined('interest0_6'),
      interest6_12: updateIfDefined('interest6_12'),
      interest12_24: updateIfDefined('interest12_24'),
      interest24_36: updateIfDefined('interest24_36'),
      interest36_48: updateIfDefined('interest36_48'),
      interest48_60: updateIfDefined('interest48_60'),
      interestBonusEnabled: updateIfDefined('interestBonusEnabled'),
      interestBonusValue: updateIfDefined('interestBonusValue')
    };

    const newAccountEmployers = account.role == accountRoles.DEBTOR ? {
      employer1: updateIfDefinedInED('employer1'),
      employer2: updateIfDefinedInED('employer2')
    } : null

    const loanObligations = account.role === accountRoles.DEBTOR && Array.isArray(profileData.loanObligations)
      ? profileData.loanObligations
      : undefined;

    actions.updateAccountProfile({
      accountId, profileData: newAccount, employersData: newAccountEmployers, loanObligations
    });
  };

  onEdit = accountId => {
    this.props.actions.setProfileEditable(accountId);
  };

  onImpersonate = accountId => {
    this.props.actions.impersonateUser({adminId: this.props.adminAccount.id, userId: accountId});
  }

  updateIdCardInfo = () => {
    const { actions, accountId } = this.props;
    actions.fetchIdCardInfo({ accountId });
  };
  getAccountUpdateLogs = () => {
    const { actions, accountId } = this.props;
    actions.fetchAccountUpdateLogs({ accountId });
  }
  onAcceptDocuments = () => {
    const { actions, accountId } = this.props;
    actions.acceptAccountDocuments({ accountId });
  };

  onRejectDocuments = rejectReason => {
    const { actions, accountId } = this.props;
    actions.rejectAccountDocuments({ accountId, rejectReason });
  };

  canImpersonate = 
    this.props.adminAccount.hasOwnProperty('profileData')
    && this.props.adminAccount.profileData.hasOwnProperty('canImpersonate')
    && this.props.adminAccount.profileData.canImpersonate;

  render() {
    const { 
      account, 
      isUpdating, 
      isFetching, 
      profileEditable, 
      isFetchingIdCardInfo, 
      isCallCentrum, 
      accountUpdateLogs, 
      documents,
      token
    } = this.props;

    if (!account) {
      return (
        <Spin spinning={isFetching}>
          <div className="spin-empty-content" />
        </Spin>
      );
    }

    return (
      <Spin spinning={isFetching}>
        <AccountProfile
          isUpdating={isUpdating}
          account={account}
          profileEditable={profileEditable}
          onSubmit={this.onSubmit}
          onEdit={this.onEdit}
          onImpersonate={this.onImpersonate}
          isFetchingIdCardInfo={isFetchingIdCardInfo}
          updateIdCardInfo={this.updateIdCardInfo}
          onAcceptDocuments={this.onAcceptDocuments}
          onRejectDocuments={this.onRejectDocuments}
          isCallCentrum={isCallCentrum}
          accountUpdateLogs={accountUpdateLogs}
          accountDocuments={documents}
          token={token}
          canImpersonate={this.canImpersonate}
        />
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/containers/AccountProfileContainer.js